/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import * as _SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import * as _EditorView from '@bingads-webui-campaign-legacy/adextension-app/view/extension-editor';
import previewTemplate from '@bingads-webui-campaign-legacy/adextension-app/template/preview.pug';
import AssociationsEditorBase from '@bingads-webui-campaign-legacy/adextension-associations-editor/view/index';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import * as $url from '@bingads-webui/url-util';
import config from '@bingads-webui-component-legacy/config/index';
import rowTemplate from '@bingads-webui-campaign-legacy/adextension-app/template/gridRowTemplate.pug';
import * as _panelDecorator from '@bingads-webui-campaign-react/panel-decorator';
var s$AppAdExtension = window.globalLegacySchema.get('AppAdExtension');
var $i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
var SharedRepository = _SharedRepository.default;
var EditorView = _EditorView.default;
var panelDecorator = _panelDecorator.panelDecorator;
var dialogOptions = {
  position: 'center',
  maxWidth: 1000
};
var defaultIconClasses = {
  'Android': 'google-play-store-icon',
  'iOS': 'apple-app-store-icon',
  'Windows Phone': 'windows-phone-store-icon',
  'Windows': 'windows-store-icon'
};
var i18nKeys = {
  title: 'AdExtensions_App_Editor_Title',
  subtitle: 'NewCampaign_AddAppAdExtension_Subtitle',
  library_title: 'AdExtensions_App_Editor_Available',
  selected_title: 'AdExtensions_App_Editor_Selected',
  create_link: 'AdExtensions_App_Editor_CreateNew',
  create_title: 'AdExtensions_App_Dialog_Title_Add',
  delete_btn: 'AdExtensions_App_Editor_Delete',
  delete_confirm: 'AdExtensions_App_Delete_Warning',
  edit_btn: 'AdExtensions_App_Editor_Edit',
  edit_title: 'AdExtensions_App_Dialog_Title_Edit'
};
var view = AssociationsEditorBase.extend({
  initialize: function (options) {
    var Editor = options && options.usePanel ? panelDecorator(EditorView, {
      i18n: $i18n,
      panelReadyAriaLabel: $i18n.getString('Association editor side panel opened'),
      panelClassName: options.panelClassName
    }) : dialogDecorator.decorate(EditorView, dialogOptions);
    _.extend(options || ({}), {
      data: new SharedRepository({
        schema: s$AppAdExtension,
        afterChangeComitted: function () {
          if (_.isFunction(options.updateContext)) {
            options.updateContext(['AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid']);
          }
        }
      }),
      template: {
        preview: previewTemplate,
        rowTemplate: rowTemplate
      },
      extensionType: 'AppExtension',
      maxSelectedItemsCount: 20,
      CreateForm: Editor,
      EditForm: Editor,
      i18nKeys: _.extend({}, i18nKeys, options.i18nKeys || ({})),
      processItem: function (item) {
        if (item.MediaUrl) {
          var adExtensionConfig = config.get('Feature').AdExtension;
          if (adExtensionConfig && adExtensionConfig.AppExtensionIconBaseUrl && item.MediaUrl.indexOf(adExtensionConfig.AppExtensionIconBaseUrl) !== 0) {
            item.MediaUrl = $url.join(adExtensionConfig.AppExtensionIconBaseUrl, item.MediaUrl);
          }
        }
        item.iconClass = defaultIconClasses[item.AppPlatform];
        return item;
      }
    });
    AssociationsEditorBase.prototype.initialize.call(this, options);
  }
});
export default view;

